export default __webpack_public_path__ + "devexpress.b7926133.png";